import type React from 'react'

// Common keyboard handler for interactive elements
export function handleKeyboardAction(
  event: React.KeyboardEvent<HTMLElement>,
  action?: Function,
): void {
  if ((event.key === 'Enter' || event.key === ' ') && action) {
    event.preventDefault()
    event.stopPropagation()
    action()
  }
}
